export default __webpack_public_path__ + "static/media/Mark-3-Suit-01.ec9762a3.jpg";